import { createFileRoute } from "@tanstack/react-router";

import { ZonesPage } from "../../../features/orders/zones-page";

export const Route = createFileRoute("/_app/settings/delivery-zones")({ component: ZonesPage });
